import { render, staticRenderFns } from "./ModifyTable.vue?vue&type=template&id=54ab5e85&scoped=true&"
import script from "./ModifyTable.vue?vue&type=script&lang=js&"
export * from "./ModifyTable.vue?vue&type=script&lang=js&"
import style0 from "./ModifyTable.vue?vue&type=style&index=0&id=54ab5e85&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ab5e85",
  null
  
)

export default component.exports